<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelWarehouseManagement.Header.name')" prop="name">
            <BjInput
              v-model="queryParams.name"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelWarehouseManagement.Header.code')" prop="code">
            <BjInput
              v-model="queryParams.code"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelWarehouseManagement.Header.status')" prop="status">
            <el-select v-model="queryParams.status" :placeholder="$t('chooseText')" clearable>
              <el-option
                v-for="(item, index) in STATUS_ENABLED_NUM"
                :key="index"
                :label="$t(item.label)"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button
            v-permission:BusinessChannelWarehouseIndex_Add
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('ChannelWarehouseManagement.Header.Add') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <el-tag
                v-else-if="col.prop === 'status'"
                :type="scope.row.status ? 'success' : 'info'"
                >{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row.status)) }}</el-tag
              >

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-permission:BusinessChannelWarehouseIndex_Edit
                type="text"
                class="edit-btn"
                @click="onEdit(props.row)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-permission:BusinessChannelWarehouseIndex_Status
                type="text"
                @click="onStatus(!props.row.status, props.row)"
                >{{ props.row.status ? $t('disableText') : $t('enableText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
import { STATUS_ENABLED_TRUE, STATUS_ENABLED_NUM } from '@/utils/constants';
import DataForm from './components/DataForm.vue';

export default {
  name: 'BusinessChannelWarehouse',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_ENABLED_TRUE,
      STATUS_ENABLED_NUM,
      queryApi: stockApi.getWarehousesPage,
      selection: false,
      // 查询参数
      queryParams: {
        name: null,
        code: null,
        status: null,
        typeCode: ['channel'],
      },
      labelsVersion: 11,
      labelList: [
        // 渠道仓编码
        {
          label: this.$t('ChannelWarehouseManagement.Header.code'),
          prop: 'code',
          isCheck: true,
          disabled: false,
        },
        // 渠道仓名称
        {
          label: this.$t('ChannelWarehouseManagement.Header.name'),
          prop: 'name',
          isCheck: true,
          disabled: false,
        },
        // 渠道仓状态
        {
          label: this.$t('ChannelWarehouseManagement.Header.status'),
          prop: 'status',
          isCheck: true,
          disabled: false,
          width: 135,
        },
        // 创建时间
        {
          label: this.$t('ChannelWarehouseManagement.Main.time'),
          prop: 'creationDate',
          isCheck: true,
          disabled: false,
          width: 135,
        },
        //  操作
        {
          label: this.$t('ChannelWarehouseManagement.Main.Operation'),
          prop: 'bjTableAction',
          isCheck: true,
          disabled: true,
          width: 135,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    /** 新增门店 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$refs.DataForm.show(this.$lodash.clone({ ...row, warehouseId: row.id }));
    },

    /** 禁用 */
    onStatus(flag, row) {
      this.$confirm(this.$t('WarehouseManagement.Main.ps1'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationWarehouse({
            ...row,
            warehouseId: row.id,
            status: flag,
          });
        })
        .catch(() => {});
    },

    // 禁用API
    operationWarehouse(API_DATA) {
      stockApi.saveChannelWarehouses(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.dialogForm {
  .el-input {
    width: 240px;
  }
}
</style>
